/**
 * Food-delivery ekranlarının paylaştığı sabitler ve saf yardımcılar.
 * (Bileşen dosyalarından ayrı tutulur; aksi halde Fast Refresh bozulur.)
 */

/** Panel içi yönlendirme hedefleri — boş ekranlardaki bağlantılar buradan. */
export const FOOD_DELIVERY_ROUTES = {
  integrations: '/integrations/food-delivery',
  orders: '/integrations/food-delivery/orders',
  mappings: '/integrations/food-delivery/mappings',
  sync: '/integrations/food-delivery/sync',
  operations: '/integrations/food-delivery/operations',
  monitoring: '/integrations/food-delivery/monitoring',
  bulk: '/integrations/food-delivery/bulk'
} as const;

/**
 * Sayfanın açılıştaki şubesi: üst menüde şube seçiliyse (şube görünümü) o
 * şube, yönetici görünümünde boş (sayfadaki seçiciden seçilir). Önceden
 * yalnız şube yöneticisi için seçiliyordu; süper admin ve şirket yöneticisi
 * şube görünümündeyken de "bir şube seçin" görüyordu.
 */
export const headerBranchId = (
  currentBranch: { id: number } | null | undefined,
  isAdminView: boolean
): number | null => (!isAdminView && currentBranch ? currentBranch.id : null);

/**
 * Adapter'ın hata mesajına eklediği "(Trendyol talep no: …)" kalıbını ayıklar.
 * Sağlayıcı desteği her başvuruda bu numarayı ister.
 */
export const extractRequestId = (message?: string | null): string | null => {
  if (!message) return null;
  const match = message.match(/talep no:\s*([^)\s]+)/i);
  return match ? match[1] : null;
};

/**
 * Sunucunun döndürdüğü hata metnini ayıklar.
 *
 * Aksiyon hataları jenerik mesajla ("… başarısız.") gösterilirse sağlayıcının
 * asıl gerekçesi ("Uyumsuz iptal nedeni girilmiştir.", "Bu işlem için teslimat
 * tipi STORE olmalıdır!") operatöre hiç ulaşmaz ve destek çağrısına dönüşür.
 */
export const serverMessage = (error: unknown, fallback: string): string => {
  const data = (
    error as { response?: { data?: { message?: string | string[] } } }
  )?.response?.data;
  const raw = data?.message;
  const text = Array.isArray(raw) ? raw.join(' ') : raw;
  return text && String(text).trim().length > 0 ? String(text) : fallback;
};

/** Panoya kopyalar; izin yoksa sessizce false döner. */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
